// extracted by mini-css-extract-plugin
export var fadeInAnimation = "subtitle-module--fadeInAnimation--7478a";
export var text = "subtitle-module--text--194fd";
export var wrapper = "subtitle-module--wrapper--6822a";